<template>
  <StudioData />
</template>
    
<script>
import StudioData from "../components/layout/FluidsDataStudioTwo/StudioData.vue";
export default {
  name: "FluidsDataStudioTwo",
  components: {
    StudioData,
  },
};
</script>